export default "/bitrix/js/landing/ui/panel/separatorpanel/dist/images/header.png"